import toast from "react-hot-toast";
import { putApi } from "./api_instance";

export const submitCompleteBidDocs = async ({
  transactionId,
  formData,
  dispatch,
}) => {
  try {
    const { data } = await putApi({
      apiUrl: `/payments/api/transactions/upload-doc?transaction_id=${transactionId}`,
      dispatch,
      sendToken: true,
      data: formData,
    });
    return data;
  } catch (error) {
    toast.error(error.message);
  }
};
